import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Response interceptor for automatic token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // refresh_token is an HttpOnly cookie — browser sends it automatically
        // No need to read it from localStorage
        await axios.post(
          `${BASE_URL}/api/auth/refresh-token`,
          {},
          { withCredentials: true }
        );

        // New access_token cookie is now set — retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh token also expired — redirect to login
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// Request interceptor — cookies sent automatically via withCredentials, no localStorage needed
api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

export default api;
